<template>
  <v-card elevation="2" class="ml-5 mr-5 mt-5 mb-5">
    <v-card-title class="justify-center">
      <v-icon>drive_file_rename_outline</v-icon> Compose Message</v-card-title
    >
    <v-card-text>
      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Title"
              type="text"
              required
              v-model="formData.title"
              @change="onChange"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              filled
              name="input-7-4"
              label="Content"
              v-model="formData.content"
              @change="onChange"
            ></v-textarea>
          </v-col>
          <v-col cols="4">
            <v-file-input
              accept="image/*"
              counter
              prepend-icon="mdi-image"
              label="Choose a image"
              truncate-length="28"
              small-chips
              v-model="formData.image_url"
              @change="onUploadImage()"
            ></v-file-input>
          </v-col>
          <v-col cols="4">
            <v-file-input
              accept="application/pdf,application/zip"
              counter
              prepend-icon="mdi-file"
              label="Choose a document"
              truncate-length="28"
              small-chips
              v-model="formData.file_url"
              @change="onUploadDocument()"
            ></v-file-input>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="receiverList"
              v-model="formData.type"
              label="Select Recipients"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" align-self="center">
            <v-btn block color="primary" dark class="mb-2 w-100" type="submit"
              >Send</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import itemTemplate from "@/components/ItemTemplate.vue";
import _ from "lodash";

export default {
  data: () => ({
    valid: true,
    receiverList: ["All Company", "My Company"],
    itemTemplate,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      { text: "Kategori Product", value: "name" },
      { text: "Actions", align: "center", value: "action", sortable: false },
    ],
    item: "",
    formData: {
      title: "",
      content: "",
      type: "",
      image_url: null,
      file_url: null,
    },
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    productImageModal: false,
    selectedCategoryProduct: null,
    fileGambarProduk: null,
    baseUrl: process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL,
  }),

  computed: {
    ...mapGetters({}),

    formTitle() {
      return this.editedIndex === -1
        ? "Buat Kategori Product"
        : "Edit Kategori Product";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      getProductCategories: "product_categories/getProductCategories",
      createProductCategories: "product_categories/createProductCategories",
      updateProductCategories: "product_categories/updateProductCategories",
      deleteProductCategories: "product_categories/deleteProductCategories",
      getCategoryProductById: "product_categories/getCategoryProductById",
      uploadImage: "product_categories/uploadImage",
      removeImage: "product_categories/removeImage",
      sendBroadcastNotification:
        "broadcast_notification/sendBroadcastNotification",
    }),
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    onClickImage(url) {
      window.open(url, "_blank");
    },
    async onRemoveImage(id) {
      try {
        const response = await this.removeImage(id);
        if (response.status === 200) {
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Hapus gambar produk berhasil!",
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addImage(data) {
      this.productImageModal = true;
    },
    onUploadImage() {
      const data = new FormData();
      data.append("image_url", this.formData.image_url);
    },
    onUploadDocument() {
      const data = new FormData();
      data.append("file_url", this.formData.file_url);
    },
    async save() {
      try {
        if (this.$refs.form.validate()) {
          if (!this.formData.type) {
            return this.$notify({
              group: "custom-notification",
              type: "error",
              title: "Error!",
              text: "Select recipient field is required!",
            });
          }
          const formData = new FormData();
          _.each(this.formData, (value, key) => {
            if (value) {
              formData.append(key, value);
            }
          });

          await this.sendBroadcastNotification(formData);
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Berhasil mengirim broadcast!",
          });
          this.formData = {
            title: "",
            content: "",
            type: "",
            image_url: null,
            file_url: null,
          };
          this.close();
        }
      } catch (e) {
        console.log(e);
      }
    },
    onChange(value) {
      //console.log(value);
    },
  },
};
</script>
<style>
.vue-suggestion .vs__input {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black;
  max-height: 400px;
  overflow-y: auto;
  font-size: 16px;
  color: black;
  position: relative;
}
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #023d7b;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #023d7b;
  border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>